import { render } from "./successCommande.vue?vue&type=template&id=3341d634&scoped=true"
import script from "./successCommande.vue?vue&type=script&lang=js"
export * from "./successCommande.vue?vue&type=script&lang=js"

import "./successCommande.vue?vue&type=style&index=0&id=3341d634&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3341d634"]])

export default __exports__